var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 136.45 107.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#a78282;}.cls-3{fill:#ac56d2;}.cls-4{opacity:0.58;mix-blend-mode:overlay;fill:url(#Degradado_sin_nombre_181);}.cls-5{fill:#9d2cc5;}.cls-6{opacity:0.48;}.cls-7{fill:none;stroke-linejoin:bevel;stroke-width:0.49px;opacity:0.5;stroke:url(#Degradado_sin_nombre_73);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_181",
    x1: -381.11,
    y1: 1225.72,
    x2: -471.04,
    y2: 1258.05,
    gradientTransform: "translate(1399.95 47.44) rotate(70.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_73",
    x1: 160.72,
    y1: 116.81,
    x2: 226.26,
    y2: 116.81,
    gradientTransform: "translate(169.58 -104.41) rotate(97.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.44,39.54C38.89,44.25,54.12,62.8,57.45,81S51,110.1,35.5,105.4,4.82,82.14,1.49,64,8,34.84,23.44,39.54Zm6,32.73c-.09,0-.15,0-.13.15a.35.35,0,0,0,.2.25c.09,0,.15,0,.13-.15a.35.35,0,0,0-.2-.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.05,101.89,136.4.75h0v0h0V.65h0V.58s0,0,0,0v0a.93.93,0,0,0,0-.13v0h0l0,0v0l0,0v0l0,0h0v0h0l0,0v0h0l0,0h-.05l0,0L136,0h-.14L116,6.21l-.61.19-.86.26-.71.22-1.69.53-1.2.37L93,13.36l-.23.08-2,.61-.22.06L87,15.23l-.92.29-1.15.36-1,.32-.55.18-.6.18-1.59.5-1.4.43L11.07,38.86l-.52.17-.15.06-.24.09-.47.19-.23.1-.11,0-.13.07-.8.41-.13.07-.07,0c-.29.16-.58.34-.85.52l0,0-.14.1c-.2.14-.41.28-.6.44l-.13.09-.1.09-.58.49-.12.1,0,0L5,42.66a.08.08,0,0,1,0,0l-.12.14-.46.53-.09.1a1.71,1.71,0,0,1-.11.14l-.39.52-.12.16-.06.09c-.15.21-.29.43-.43.65l-.08.12v0c-.17.28-.33.55-.48.84l0,.06a1,1,0,0,0-.09.18c-.12.21-.22.43-.33.65a.91.91,0,0,1-.07.14.87.87,0,0,1-.07.17c-.1.22-.19.44-.28.67a1.67,1.67,0,0,0-.08.2.42.42,0,0,0,0,.1c-.12.33-.24.66-.35,1h0v0c-.11.35-.21.7-.31,1l0,.13c0,.06,0,.13-.05.19-.07.3-.14.59-.2.89a1.46,1.46,0,0,1-.05.2s0,.07,0,.1Q.45,52.39.36,53l0,.08c0,.06,0,.12,0,.18,0,.4-.09.8-.13,1.21,0,.06,0,.12,0,.18v.09c0,.49-.07,1-.08,1.49,0,.05,0,.09,0,.14v.18c0,.54,0,1.09,0,1.65v0s0,.09,0,.13c0,.51,0,1,.09,1.54a1.15,1.15,0,0,1,0,.19s0,.08,0,.11c0,.51.1,1,.16,1.55a.34.34,0,0,1,0,.1c0,.09,0,.18,0,.28,0,.35.1.71.16,1.06l0,.25c0,.19.07.37.1.55s.11.58.17.87l.12.57c0,.16.07.32.11.47s0,.17.05.26c.1.42.2.83.31,1.25v0l0,.1c.09.35.19.71.29,1.06,0,.12.07.25.11.37s.09.3.14.45.08.28.13.42.15.46.22.68l.18.55a1.72,1.72,0,0,1,.07.21c.05.14.11.28.15.41.18.49.35,1,.54,1.44l.12.33c.08.19.16.38.23.57l.2.48q.28.69.6,1.38l.06.15v0l.08.17c.26.57.53,1.13.8,1.69l.09.18.53,1,.07.14.13.24c.12.22.23.44.35.65s.29.53.44.8h0v0c.13.24.27.48.41.71s.29.5.44.74l.06.1a.75.75,0,0,0,.07.12c.1.17.2.34.31.51l.44.7.15.23.09.15.21.31.45.69.26.37.11.17c.05.07.1.14.14.21l.54.75.28.39.12.17.14.19c.2.28.4.55.61.82l.22.28c.06.09.13.17.2.26l.25.33.69.85a.27.27,0,0,0,.07.08l.17.21.57.69.32.37.3.34.23.27.71.78.18.2.05,0c.33.36.66.71,1,1.06l.1.09.35.36.61.61.22.21.47.45.42.4.34.3.51.47.32.28.44.38.52.44.23.2c.18.15.36.28.53.43l.57.45.17.14.6.44.57.44.13.09c.2.15.4.28.59.41s.45.33.68.48l.13.09.51.33.82.53.15.09c.15.1.3.18.45.27l.92.54.21.12.36.19c.37.2.74.4,1.12.59l.32.17.42.2.37.17q.64.3,1.29.57h0c.47.19.93.37,1.4.54l.46.16c.26.09.53.19.8.27l.28.09C43.44,108.61,50.05,106.8,54.05,101.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54,102,136.32.86h0v0h0v0h0V.62a.5.5,0,0,0,0-.13l0,0h0l0,0,0,0v0l0,0,0,0h0l0,0v0l0,0h0l0,0,0,0h0l0,0,0,0-.06,0a.23.23,0,0,0-.14,0L115.9,6.31l-.61.19-.86.27-.7.22-1.7.53-1.2.37L92.91,13.47l-.23.07-2,.61-.22.07-3.6,1.12-.93.29L84.83,16l-1,.32-.55.17-.6.19L81,17.16l-1.4.44L11,39l-.51.17-.16,0-.24.1-.47.19-.22.09-.11,0-.14.07c-.27.13-.54.26-.8.41l-.13.06-.06,0c-.3.17-.58.34-.86.53l0,0-.14.1-.6.44-.12.1a.87.87,0,0,0-.11.09c-.2.16-.39.32-.57.49l-.12.1,0,0q-.34.31-.66.66a.08.08,0,0,0,0,0L4.73,43c-.16.17-.31.34-.46.52l-.09.11a.76.76,0,0,0-.11.14l-.4.51a1,1,0,0,1-.12.16l-.06.1c-.15.21-.29.43-.43.65L3,45.26v0q-.26.4-.48.84l0,.05-.09.18c-.11.22-.22.44-.32.66L2,47.15c0,.05-.05.11-.08.17-.09.22-.19.44-.28.67,0,.06-.05.12-.08.19l0,.1c-.13.33-.25.67-.36,1h0v0q-.16.51-.3,1l0,.12a1.42,1.42,0,0,0,0,.2c-.08.29-.14.59-.21.89,0,.07,0,.13,0,.2s0,.06,0,.09c-.08.42-.15.84-.21,1.27,0,0,0,0,0,.08a1.11,1.11,0,0,0,0,.17c-.06.4-.1.81-.14,1.22a1.1,1.1,0,0,1,0,.18v.08c0,.49-.06,1-.08,1.5v.14a1,1,0,0,0,0,.17c0,.54,0,1.1,0,1.66v.17c0,.5.05,1,.1,1.53a1.15,1.15,0,0,0,0,.19s0,.08,0,.12c0,.51.1,1,.17,1.54a.41.41,0,0,0,0,.11c0,.09,0,.18,0,.27,0,.35.1.71.16,1.07a2.17,2.17,0,0,0,0,.25c0,.18.06.36.1.55s.1.57.16.86.09.39.13.58.06.31.1.47l.06.26c.09.41.2.83.31,1.24v0l0,.11c.1.35.19.7.29,1.06l.12.37c0,.15.09.3.13.45s.08.28.13.42.15.45.22.68.12.37.19.55a1.72,1.72,0,0,0,.07.21c0,.14.1.27.15.41.17.48.35,1,.53,1.44.05.11.08.22.13.33s.15.38.23.56l.19.48L4.43,76l.07.14v0a1.3,1.3,0,0,0,.08.17c.26.56.52,1.12.8,1.68l.08.18.53,1a.83.83,0,0,1,.07.13c0,.08.09.16.13.24l.35.66L7,81.1v0l.41.71.44.74.06.1L8,82.8l.31.51.44.7.15.23.1.15c.06.11.13.21.2.32s.3.46.46.69l.25.37.12.17a1.43,1.43,0,0,0,.14.2c.17.26.35.51.53.76l.28.39.13.17c0,.06.09.12.13.19l.61.81.22.29.2.25.26.33c.22.29.45.58.68.86l.07.08.17.2c.19.23.38.47.58.7l.32.37.3.34.23.27.71.78.18.2,0,.05,1,1,.1.1c.12.12.24.23.35.35l.61.62.23.21.46.44.42.4.34.31.52.46.31.28.45.38.52.45.23.2.53.42.56.45.17.14.6.45.58.43.13.1.58.41.69.48.12.08.52.34.81.52.16.1.45.27.91.53.22.13c.12.07.24.12.35.19.38.2.75.4,1.12.58l.32.17.43.2.37.18q.64.3,1.29.57h0c.46.19.93.37,1.39.54l.46.15.8.28.28.08C43.36,108.72,50,106.91,54,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23,39.24C38.72,44,54.19,62.87,57.57,81.34S51,110.9,35.28,106.13,4.11,82.5.73,64,7.33,34.46,23,39.24Zm6.09,33.25c-.09,0-.15,0-.13.14a.34.34,0,0,0,.21.25c.09,0,.15,0,.13-.15a.32.32,0,0,0-.21-.24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M23.07,39.5C38.64,44.24,54,62.94,57.35,81.27s-6.55,29.34-22.12,24.59S4.31,82.42,1,64.1,7.5,34.76,23.07,39.5Zm6,33c-.09,0-.15,0-.13.14a.34.34,0,0,0,.21.25c.09,0,.15,0,.13-.15a.32.32,0,0,0-.21-.24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset17);
export default __webpack_public_path__ + "static/media/asset17.79d4da255f8f4823da7eff83275554fe.svg";
export { ForwardRef as ReactComponent };